import { IScoreEntry } from '../../Utility/SDK/ISDKDriver';
import { ICardsState } from '../Card/CardReducer';
import { HelperFriendStatus } from './HelperFriend/HelperFriendStatus';
import { getDefaultBoosterPrices } from './LevelStateHelper';
import { LevelTask } from './LevelTask';

export enum LevelStatus {
    EMPTY = 'empty',
    LOADING = 'loading',
    LOADED = 'loaded',
    INTRO = 'intro',
    ACTIVE = 'active',
    COMPLETE = 'complete',
    FAILED = 'failed',
    EXITING = 'exiting',
    RESTARTING = 'restarted',
}

export enum LevelType {
    SAGA = 'saga',
    CHALLENGE = 'challenge',
}

export interface ILevelStateTaskData {
    task?: LevelTask;
    [key: string]: any;
}

export enum LevelComponent {
    BONUS_STREAK = 'bonus_streak',
    COINS_DISPLAY = 'coins_display',
    SETTINGS = 'settings',
    SUITCASE = 'suitcase',
    BOOSTER_UNDO = 'booster_undo',
    BOOSTER_JOKER = 'booster_joker',
    BOOSTER_PLUS_FIVE = 'booster_plus_five',
    BOOSTER_TNT = 'booster_tnt',
    BOOSTER_BULLS_EYE = 'booster_bulls_eye',
    BOOSTER_SHUFFLE = 'booster_shuffle',
}

export interface ILevelCompleteData {
    levelNumber: number;
    score: number;
    stars: number;
    coins: number;
}

export interface ILevelBoosterPrices {
    bullsEye: number;
    joker: number;
    plusFive: number;
    shuffle: number;
    tnt: number;
    undo: number;
}

export enum WinCriteriaType {
    CLEAR_ALL = 'clear_all',
    CLEAR_GOLD = 'clear_gold',
}

export interface IWinCriteriaData {
    type: WinCriteriaType;
}

export interface ILevelState {
    levelNumber: number;
    levelPath: string;
    levelType: LevelType;
    levelId: string;
    attempts: number;
    status: LevelStatus;
    cardsState: ICardsState;
    winCriteria: IWinCriteriaData[];
    score: number;
    bonus: number;
    stars: number[];
    coins: number[];
    firstAttempt: boolean;
    leaderboard: IScoreEntry[];
    completeData: ILevelCompleteData;
    components: LevelComponent[];
    tasks: ILevelStateTaskData[];
    boosterPrices: ILevelBoosterPrices;
    helperFriendStatus: HelperFriendStatus;
}

export const initialLevelState: ILevelState = {
    levelNumber: undefined,
    levelPath: undefined,
    levelType: undefined,
    levelId: undefined,
    attempts: 0,
    status: LevelStatus.EMPTY,
    cardsState: undefined,
    winCriteria: [],
    score: 0,
    bonus: 0,
    stars: [],
    coins: [],
    firstAttempt: false,
    leaderboard: [],
    completeData: undefined,
    components: [],
    tasks: [],
    boosterPrices: getDefaultBoosterPrices(),
    helperFriendStatus: HelperFriendStatus.DISABLED,
};
